module.exports = __webpack_public_path__ + "static/co_founder_bottom_mobile-5f5b2dafeebb5f1b019d6ee9ca303528.png";